import React from 'react';
import { demoStatusLabels, type DemoStatus } from '../../data/demoCenter';
const styles: Record<DemoStatus, {
  badge: string;
  dot: string;
}> = {
  interactive: {
    badge: 'bg-teal-pale text-navy border border-teal/30',
    dot: 'bg-teal'
  },
  scoped: {
    badge: 'bg-lavender-pale text-[#4446A8] border border-lavender/30',
    dot: 'bg-lavender'
  },
  planned: {
    badge: 'bg-surface-muted text-ink-muted border border-line',
    dot: 'border border-ink-muted'
  }
};
export function DemoStatusBadge({
  status
}: {
  status: DemoStatus;
}) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${styles[status].badge}`} data-id="element-350" data-mp="6zpr5en2qose">
      <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${styles[status].dot}`} data-id="element-351" data-mp="gx44v6hm4zh0" />
      {demoStatusLabels[status].label}
    </span>;
}